/** Textos da seção Calculadora de receita na landing (público). */

export const LANDING_RESULTS_CALCULATOR_PLANS_CTA_LABEL = 'Ver planos disponíveis';
